import { render, staticRenderFns } from "./CBProposalOverview.vue?vue&type=template&id=24fed100"
import script from "./CBProposalOverview.vue?vue&type=script&lang=js"
export * from "./CBProposalOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports